import React, { useEffect, useState } from 'react';
import { useAuth } from '../App';
import Layout from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

export default function AdminExchange() {
  const { axiosInstance } = useAuth();

  const [exchanges, setExchanges] = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("pending");

  const fetchPending = async () => {
    try {
      const res = await axiosInstance.get('/exchanges/admin/pending');
      setExchanges(res.data);
    } catch {
      toast.error("Erreur chargement admin exchanges");
    } finally {
      setLoading(false);
    }
  };

  const fetchHistory = async () => {
    try {
      const res = await axiosInstance.get('/exchanges/admin/history');
      setHistory(res.data);
    } catch {
      toast.error("Erreur chargement historique");
    }
  };

  useEffect(() => {
    fetchPending();
    fetchHistory();
  }, []);

  const confirm = async (id) => {
    try {
      await axiosInstance.post(`/exchanges/admin/confirm/${id}`);

      toast.success("Prestation transférée");

      fetchPending();
      fetchHistory();

    } catch {
      toast.error("Erreur confirmation");
    }
  };

  if (loading) {
    return (
      <Layout title="Admin Exchanges">
        Chargement...
      </Layout>
    );
  }

  return (
    <Layout title="Validation des échanges">

      <div className="flex gap-2 mb-4">
        <Button
          variant={tab === "pending" ? "default" : "outline"}
          onClick={() => setTab("pending")}
        >
          À valider
        </Button>

        <Button
          variant={tab === "history" ? "default" : "outline"}
          onClick={() => setTab("history")}
        >
          Historique
        </Button>
      </div>

      {/* ONGLET VALIDATION */}

      {tab === "pending" && (
        <div className="space-y-4">

          {exchanges.length === 0 && (
            <Card>
              <CardContent className="p-6 text-center text-gray-500">
                Aucun échange à valider
              </CardContent>
            </Card>
          )}

          {exchanges.map((e) => (
            <Card key={e.id} className="border-amber-200">
              <CardContent className="p-4 space-y-2">

                <div className="font-bold text-amber-900">
                  Prestation : {e.prestation_name || e.prestation_id}
                </div>

                <div className="text-sm text-gray-600">
                  De : {e.requester_name}
                </div>

                <div className="text-sm text-gray-600">
                  Vers : {e.target_name}
                </div>

                <div className="border rounded-lg p-3 bg-gray-50 space-y-1 text-sm">

                  <div>
                    <strong>Type :</strong> {e.type_soignant || "—"}
                  </div>

                  <div>
                    <strong>Établissement :</strong> {e.etablissement_name || "—"}
                  </div>

                  <div>
                    <strong>Début :</strong>{" "}
                    {e.date_start
                      ? new Date(e.date_start).toLocaleString("fr-BE")
                      : "—"}
                  </div>

                  <div>
                    <strong>Fin :</strong>{" "}
                    {e.date_end
                      ? new Date(e.date_end).toLocaleString("fr-BE")
                      : "—"}
                  </div>

                  <div>
                    <strong>Durée :</strong>{" "}
                    {e.dureeMinutes
                      ? `${Math.floor(e.dureeMinutes / 60)}h${String(
                          e.dureeMinutes % 60
                        ).padStart(2, "0")}`
                      : "—"}
                  </div>

                  <div>
                    <strong>Tarif horaire :</strong> {e.base_rate ?? "—"} €
                  </div>

                  <div>
                    <strong>Montant total :</strong> {e.final_rate ?? "—"} €
                  </div>

                  <div>
                    <strong>Statut :</strong> {e.status}
                  </div>

                </div>

                <div className="mt-3">
                  <Button
                    onClick={() => confirm(e.id)}
                    className="bg-blue-600"
                  >
                    Valider transfert
                  </Button>
                </div>

              </CardContent>
            </Card>
          ))}

        </div>
      )}

      {/* ONGLET HISTORIQUE */}

      {tab === "history" && (
        <div className="space-y-4">

          {history.length === 0 && (
            <Card>
              <CardContent className="p-6 text-center text-gray-500">
                Aucun historique d’échange
              </CardContent>
            </Card>
          )}

          {history.map((e) => (
            <Card key={e.id} className="border-gray-200">
              <CardContent className="p-4 space-y-2">

                <div className="font-bold text-gray-900">
                  Prestation : {e.prestation_name || e.prestation_id}
                </div>

                <div className="text-sm text-gray-600">
                  Ancien prestataire : {e.requester_name}
                </div>

                <div className="text-sm text-gray-600">
                  Nouveau prestataire : {e.target_name}
                </div>

                <div className="text-sm text-gray-600">
                  Type : {e.type_soignant || "—"}
                </div>

                <div className="text-sm text-gray-600">
                  Début : {e.date_start
                    ? new Date(e.date_start).toLocaleString("fr-BE")
                    : "—"}
                </div>

                <div className="text-sm text-gray-600">
                  Fin : {e.date_end
                    ? new Date(e.date_end).toLocaleString("fr-BE")
                    : "—"}
                </div>

                <div className="text-sm font-semibold">
                  Statut : {e.status === "completed"
                    ? "✅ Validé et transféré"
                    : "❌ Refusé"}
                </div>

                <div className="text-xs text-gray-400">
                  Dernière modification : {e.updated_at
                    ? new Date(e.updated_at).toLocaleString("fr-BE")
                    : "—"}
                </div>

              </CardContent>
            </Card>
          ))}

        </div>
      )}

    </Layout>
  );
}